import React from "react";
import PortData from "./PortData";
import "./portfolio.css";

const Portfolio = () => {
  return <PortData />;
};

export default Portfolio;
